import { UploadControllerRegistry } from "../ports/UploadControllerRegistry";

export class CancelUploadUseCase {
  constructor(private readonly controllerRegistry: UploadControllerRegistry) {}

  execute(taskId: string): void {
    const controller = this.controllerRegistry.get(taskId);
    if (!controller) {
      return;
    }

    controller.cancel();
    this.controllerRegistry.remove(taskId);
  }
}

